import { render, staticRenderFns } from "./BaseSerch.vue?vue&type=template&id=3e9e708c&"
import script from "./BaseSerch.vue?vue&type=script&lang=js&"
export * from "./BaseSerch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports